{
  "en": {
    "surveys": {
      "buttons": {
        "addAnswer": "Add option",
        "edit": "Click to edit",
        "moveQuestionDown": "Move question down",
        "moveQuestionUp": "Move question up",
        "removeOption": "Remove option",
        "removeQuestion": "Remove question"
      },
      "confirm": {
        "deleteQuestionText": "This action cannot be undone. The question and all its answer options will be permanently removed from the survey.",
        "deleteQuestionTitle": "Delete question?",
        "requiredIncompleteText": "You have not yet filled in all required fields (marked with *). Please complete them to submit the survey.",
        "requiredIncompleteTitle": "Required fields missing",
        "submitIncompleteText": "You have not yet answered all questions. Your response will still be submitted.",
        "submitIncompleteTitle": "Submit response?"
      },
      "flash": {
        "questionAdded": "Question added",
        "questionDeleted": "Question deleted",
        "questionMoved": "Question moved",
        "questionUpdated": "Question updated",
        "submitFailed": "Your answer could not be submitted. Please try again."
      },
      "headers": {
        "answers": "Results",
        "general": "Title and description",
        "lastAnswered": "Last answered",
        "questions": "Questions",
        "responsesPerQuestion": {
          "answers": "{count} answer | {count} answers",
          "oClock": "o'clock",
          "of": "of",
          "responses": "{count} response | {count} responses"
        },
        "shareResultsLink": "Share this link to the results of this survey"
      },
      "hints": {
        "average": "Average",
        "evaluations": "{count} rating | {count} ratings",
        "file": "Create an assignment for your students to upload a file (e.g., a text file, an image, or a PDF).",
        "long_answer": "Write a work assignment for which your students can digitally submit a response in a text field.",
        "maxOptionsReached": "Maximum of {max} options can be added.",
        "multiple_choice": "Ask a question and provide possible answers. More than one answer can be selected.",
        "noDescriptionOrOptions": "No description or options entered",
        "notAnswered": "not specified",
        "rating": "Have your students rate something from 1-5 stars.",
        "required": "Question must be answered",
        "single_choice": "Ask a question and provide possible answers. Only one answer can be selected.",
        "submitSuccessful": "Thanks for completing this survey."
      },
      "inserter": {
        "title": "Add new block"
      },
      "labels": {
        "backToResponseIndex": "Back to overview",
        "loadingResponses": "Loading responses...",
        "required": "Mandatory",
        "showAllAnswers": "Show details"
      },
      "placeholders": {
        "description": "Add description",
        "optionInput": "Enter option here...",
        "question": "Question",
        "title": "Enter title here..."
      },
      "questionTypes": {
        "file": "File Submission",
        "long_answer": "Text Response",
        "multiple_choice": "Multiple Choice",
        "net_promoter_score": "Net Promoter Score (0-10)",
        "rating": "Rating",
        "single_choice": "Single Choice"
      },
      "tabs": {
        "submissions": "Submissions",
        "survey": "Survey"
      }
    }
  }
}
